import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const DashboardBuilderWrapper = lazy(() =>
  import("@scenes/DashboardBuilder/DashboardBuilderWrapper").then((module) => ({
    default: module.DashboardBuilderWrapper,
  }))
);

export const dashboardBuilderNRO: NavigationRoutingObject = {
  Component: DashboardBuilderWrapper,
  componentFeatureFlippers: [],
  section: "analytics",
  heading: (t: I18nT<"dashboard-navigation">) =>
    t("dashboard-builder-sidebar-pill-menu-option", "Dashboard Builder"),
  pageNameForTracking: () => "Dashboard Builder",
  getDeveloperNavigationAllowed: ({ isImpersonating, hasPermission }) => {
    const userHasViewAppUsagePermission = hasPermission("appGroup", {
      permission: "viewAppUsage",
    });
    return isImpersonating || userHasViewAppUsagePermission;
  },
  additionalSearchTerms: (t: I18nT<"dashboard-navigation">) => [
    {
      keywords: [t("dashboard-builder-alt-keyword-1", "Dashboard Builder")],
    },
  ],
  additionalSearchableFeatures: () => ({}),
  defaultRoute: "/dashboard/report_dashboard/:appGroupId",
  noKnockoutFallback: true,
};
